import Brandmark from "@/components/logo/Brandmark";
import NumerousLogo from "@/components/logo/NumerousLogo";
import { getWhiteLabelBrand } from "./getWhiteLabelBrand";

// eslint-disable-next-line import/no-unused-modules
export const WhiteLabelBrandLogo = () => {
  const brand = getWhiteLabelBrand();

  if (brand) {
    return (
      <div className="scale-150">
        <brand.Logo />
      </div>
    );
  }

  return (
    <NumerousLogo
      type="fullLogo"
      size="md"
      className="dark:text-brand-gray-50"
    />
  );
};

export const WhiteLabelBrandSidebarLogo = () => {
  const brand = getWhiteLabelBrand();

  if (brand) return <brand.Logo />;

  return <Brandmark />;
};
